import './form.scss'; // [拡張子なしのこのファイル名].css にバンドルされる

import getCheckedValues from './js/get-checked-values';
import postForm from './js/post-form';

/** @type {HTMLFormElement} */
const form = document.querySelector('[data-form="inquiry"]');

form.addEventListener('submit', (ev) => {
  ev.preventDefault();

  const inquiryType = getCheckedValues(
    Array.from(document.querySelectorAll('[name=inquiryType]'))
  );

  const howYouFoundOut = getCheckedValues(
    Array.from(document.querySelectorAll('[name=howYouFoundOut]'))
  );

  /** @type {HTMLInputElement} */
  const yourLastName = document.querySelector('[name=yourLastName]');
  /** @type {HTMLInputElement} */
  const yourFirstName = document.querySelector('[name=yourFirstName]');
  /** @type {HTMLInputElement} */
  const yourLastNameKana = document.querySelector('[name=yourLastNameKana]');
  /** @type {HTMLInputElement} */
  const yourFirstNameKana = document.querySelector('[name=yourFirstNameKana]');

  /** @type {HTMLInputElement} */
  const yourAddress = document.querySelector('[name=yourAddress]');

  /** @type {HTMLInputElement} */
  const yourPhoneNumber = document.querySelector('[name=yourPhoneNumber]');

  /** @type {HTMLInputElement} */
  const yourEmail = document.querySelector('[name=yourEmail]');

  const preferredNursery = getCheckedValues(
    Array.from(document.querySelectorAll('[name=preferredNursery]'))
  );

  /** @type {HTMLTextAreaElement} */
  const inquiryContent = document.querySelector('[name=inquiryContent]');

  if (form.reportValidity()) {
    const data = new FormData();

    // flamingo's value
    data.append('your-subject', 'お問い合わせ');
    data.append('your-name', `${yourLastName.value} ${yourFirstName.value}`);
    data.append('your-email', yourEmail.value);

    data.append('inquiryType', inquiryType);
    data.append('howYouFoundOut', howYouFoundOut);
    data.append('yourLastName', yourLastName.value);
    data.append('yourFirstName', yourFirstName.value);
    data.append('yourLastNameKana', yourLastNameKana.value);
    data.append('yourFirstNameKana', yourFirstNameKana.value);
    data.append('yourAddress', yourAddress.value);
    data.append('yourPhoneNumber', yourPhoneNumber.value);
    data.append('yourEmail', yourEmail.value);
    data.append('preferredNursery', preferredNursery);
    data.append('inquiryContent', inquiryContent.value);

    // Required
    data.append('_wpcf7_unit_tag', 'wpcf7-f54120-o1');

    postForm(54120, data);
  }
});
